// External unreferenced import
import React from "react";

// External
import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Local
import "./index.css";
import App from "./App";

// Routes
// @TODO: Add routes here.

ReactDOM.render(
    <StrictMode>
        <BrowserRouter basename={window.location.pathname}>
            <Routes>
                <Route path="/" element={<App />}></Route>
            </Routes>
        </BrowserRouter>
    </StrictMode>,
    document.getElementById("root")
);
